<template>
    <div class="paybox">
        <div class="global-loading" v-show="loading">
            <div class="global-loading-content">
                <img class="loadingImg" src="https://imgpub1.shouqiev.com/gofunplatform/files/20220805/eLnRJKdxjt.gif" />
            </div>
        </div>
        <div class="tabpay">
            <ul v-if="h5_pay">
                <li class="tabpayzfb" :class="payMsg.payType==2 ? 'active' : false" @click="changePayType(2)" payType="2">
                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220805/MVZFjPYnyD.png" alt=""><span>支付宝</span>
                </li>
                <li class="tabpaywx" :class="payMsg.payType==3 ? 'active' : false" @click="changePayType(3)" payType="3">
                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220805/POiwBMElGe.png"><span>微信</span>
                </li>
            </ul>
            <ul v-else>
                <li class="tabpayzfb tabpayH5 active">
                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220805/MVZFjPYnyD.png" alt=""><span>H5支付宝</span>
                </li>
                <div id="alipay-box"></div>
            </ul>
        </div>
        <div class="go_pay" @click="h5pay">去支付</div>
        <div class="pay_tip" v-if="paytip" style="text-align:center;">
            <div class="pay_tip_con">
                <p>{{paytipconent}}</p>
                <span @click="tip_close">关闭</span>
            </div>
        </div>
    </div>
</template>

<script>
    import baseUrl from '../server-config'
    import axios from '@/libs/http/axios-others'
    import jsBridge from '@/libs/jsBridge'
    import { Toast } from 'mint-ui';
    import { getPayTypeList, goPay_api} from "../api.js"

    export default {
        name: 'paybox',
        data() {
            return {
                timer:"",
                loading: false,
                active: true, //选中
                paytip: false, //提示框
                paytipconent: '', //成功失败提示内容
                payMsg: {
                    payType: 2,  //2支付宝  微信3   H5支付宝8   H5微信4
                    appVersion: 5540, //app版本
                    orderId:'' //订单ID
                },
                result: {}, //支付宝  微信返回
                payDesc:'',//支付成功》回首页提示内容
                h5_pay:true,//h5支付，默认客户端支付
                repeat_pay:false,//重复支付

                list: {
                    "mall":{apiPath:"/shopPayment/pay"}
                },
                apiPath:"",
                sourceRouter:""
            }
        },
        created(){
            this.pathInit()
        },
        destroyed(){
            clearTimeout(this.timer)
        },
        methods: {
            pathInit(){
                getPayTypeList().then(res=>{
                    console.log("支付类型列表",res)
                })
                let source = this.$route.query.from
                if(!source) {
                    Toast("支付参数异常")
                    console.error("不知道应该给哪个项目收钱")
                    return false;
                }
                // this.apiPath = this.list[source].apiPath,
                this.sourceRouter = this.$route.query.returnRouter
            },
            changePayType(type){
                this.payMsg.payType = type;
                console.log("支付方式",type)
            },
            appPayCallback(data){
                console.log('支付返回的data :', data,data == 'true',data == 'false')
                console.log('订单id',this.$route.query.orderId)
                if (data == 'true') {
                    console.log(axios,"IN appPayCallback")
                    this.loading = true
                    // getPayResult().then(res=>{})
                    console.log({baseUrl})
                    axios.get(baseUrl+'/coupon/getPayResult',{
                        params:{
                            orderId:this.$route.query.orderId,
                            payType:this.payMsg.payType,
                            thirdPayNo:this.result.thirdPayNo,
                        },
                        noLoading:true
                    })
                    .then((response) => {
                        if(response.data.code == 200){
                            // 1:处理中，2：成功，3：失败，4：关闭
                            if(response.data.result.payStatus==2){
                                if(this.sourceRouter){
                                    this.$router.replace({
                                        path:this.sourceRouter,
                                        query:{
                                            orderId:this.$route.query.orderId,
                                            desc:response.data.result.paySuccessText
                                        }
                                    })
                                } else {
                                    this.$router.go(-1)
                                }
                            }
                            console.log('状态response :', response)

                            if(response.data.result.payStatus == 3){
                                console.log('3秒后重新查询接口')
                                this.timer = setTimeout(()=>{
                                    console.log('3秒后开始查询')
                                    this.appPayCallback("true")
                                },3000)
                            }
                        } else {
                            this.loading = false
                            this.$toast("支付查询失败")
                            this.loading = true
                            console.log('3秒后重新查询接口')
                            this.timer = setTimeout(()=>{
                                console.log('3秒后开始查询')
                                this.appPayCallback("true")
                            },3000)
                        }
                        return false
                        this.loading = false
                        this.payDesc = response.result.payDesc;

                    })
                    .catch(function(error) {
                        console.log(error);
                        this.timer = setTimeout(()=>{
                            this.appPayCallback("true")
                        },3000)
                    });
                }
                if (data == 'false') {
                    this.paytip = true;
                    this.paytipconent = '支付失败';
                }
            },
            //点击去支付
            h5pay() {
                this.loading = true
                let params = {
                    ...this.payMsg,
                    orderId:this.$route.query.orderId,
                    payAmount:this.$route.query.payAmount
                }
                goPay_api(params)
                    .then((response) => {
                        console.log(response);
                        this.loading = false
                        if(response.code == 200) { //200
                            this.result = response.result;
                            console.log(this.payMsg.payType == 3 ? "微信支付" : this.payMsg.payType == 2 ?"支付宝":"H5支付宝")
                            if(this.payMsg.payType == 3) { //微信
                                if(response.result.packageValue == null || response.result.sign == null || response.result.prepayId == null || response.result.noncestr == null || response.result.timestamp == null || response.result.thirdPayNo == null) {
                                    this.paytip = true;
                                    this.paytipconent = response.message;
                                } else {
                                    jsBridge.toPay(this.payMsg.payType, JSON.stringify(this.result), 'test')
                                }
                            }else if(this.payMsg.payType == 2) { //支付宝
                                console.log("jsbridge去支付",window.test)
                                console.log(jsBridge.toPay)
                                jsBridge.toPay(this.payMsg.payType, JSON.stringify(this.result), 'test')
                            }else if(this.payMsg.payType == 8){ //h5支付宝
                                localStorage.clickPay = true // 第一次存
                                localStorage.orderId = this.$route.query.orderId // 第一次存
                                response.result.form && (document.querySelector('#alipay-box').innerHTML = response.result.form)
                                document.forms[0] && (document.forms[0].submit())
                            }
                        }else if(response.code == 202 ){ //低版本重复下单
                            this.payDesc = '请在购买记录查看';
                            sessionStorage.setItem('payDesc',this.payDesc) ;// 返回内容
                            sessionStorage.setItem('payDescType','1'); //payDescType 1成功
                            console.log("重复支付",this.$route)
                            this.$router.replace({
                                path: this.$route.query.returnRouter
                            })
                        }else { //失败返回
                            this.paytip = true;
                            this.paytipconent = response.message;
                        }

                    })
                    .catch(function(error) {
                        console.log(error);
                        this.loading = false
                    });

            },
            //关闭提示
            tip_close: function() {
                this.paytip = !this.paytip;
            },
        },
        mounted() {
            console.log({
                "项目来源：":this.$route.query.from,
                "支付路径：":this.apiPath,
                "前端项目路径":this.sourceRouter,
            })
            this.payMsg.appVersion = JSON.parse(jsBridge.getReportInfo()).appVersion || 5540
            window.test = (arg)=>{
                this.appPayCallback(arg)
            }
        }
    }
</script>

<style scoped>
@import '../common.css';

    .global-loading {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 10000;
        background: rgba(80,90,115,0.30);
    }
    .global-loading-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        width: 220px;
        height: 220px;
        background: #fff;
        box-shadow: 0 8px 14px 0 rgba(0,0,0,0.10);
        border-radius: 30px;

    }

    .loadingImg{
        width: 100%;
        height: 100%;
    }
    .loadingImg{
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%, -50%);
    }
    .tototo{
        display: none !important;
    }
    .pay_tip {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(20, 30, 37, 0.46);
        z-index: 100;
    }

    .pay_tip_con {
        position: fixed;
        top: 50%;
        left: 50%;
        -webkit-transform: translate3d(-50%,-50%,0);
        transform: translate3d(-50%,-50%,0);
        background-color: #fff;
        width: 80%;
        border-radius: 0.15rem;
        font-size: 0.213333rem;
        -webkit-user-select: none;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: .2s;
        transition: .2s;
    }
    .pay_tip_con p{
        padding: 1rem 10% 0.5rem 10%;
        min-height: 50px;
        color: #999;
        margin: 0;
        text-align: center;
        line-height: 36px;
        font-size: 0.3733rem;
    }
    .pay_tip_con span {
        width: 100%;
        height: 1.1rem;
        line-height: 1.1rem;
        border-top: 1px solid #ddd;
        display: inline-block;
        margin-top: 5%;
        color: #26a2ff;
        font-size: 0.426rem;
    }

    .paybox {
        box-sizing: border-box;
        height: 100vh;
        background: #eef3f1;
        padding-top: 30px;
    }

    .tabpay {
        width: 8.9333rem;
        margin-left: 0.5333rem;
        background: #fff;
        border-radius: 0.34667rem;
    }

    .tabpay li {
        padding: 0.50333rem 0.4533rem;
        color: #141E25;
        font-size: 0.4rem;
        border-bottom: 2px solid #DCE0DF;
        background: url('https://imgpub1.shouqiev.com/gofunplatform/files/20220805/ecczNXqxvM.png') no-repeat;
        background-position: center right;
        background-position-x: 7.867rem;
        background-size: 0.5333rem;
    }

    .tabpay .active {
        padding: 0.50333rem 0.4533rem;
        color: #141E25;
        font-size: 0.4rem;
        border-bottom: 2px solid #DCE0DF;
        background: url('https://imgpub1.shouqiev.com/gofunplatform/files/20220805/mTgJFtcSnx.png') no-repeat;
        background-position: center right;
        background-position-x: 7.867rem;
        background-size: 0.5333rem;
    }

    .tabpay li:last-child {
        border-bottom: none;
    }

    .tabpayzfb img {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 15px;
        vertical-align: middle;
    }

    .tabpaywx img {
        width: 0.8533rem;
        height: 0.7466rem;
        margin-right: 15px;
        vertical-align: middle;
    }

    .go_pay {
        position: fixed;
        bottom: 0.5333rem;
        background: #272828;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.10);
        border-radius: 55px;
        height: 1.4667rem;
        width: 8.9333rem;
        left: 0.5333rem;
        line-height: 1.4667rem;
        color: #fff;
        text-align: center;
        font-size: 0.48rem;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.10);
    }
    .go_pay:active{
        opacity: 0.7;
    }
</style>



// WEBPACK FOOTER //
// pay.vue?1faac588